import React, { Component } from "react";
import { func, string, array, bool } from "prop-types";
import moment from "moment";
import { Form, Button, DatePicker, TimePicker } from "antd";

import { Select } from "../../generic";
import { IconLight } from "../../";

import "./dateRangePicker.css";

const TODAY = moment().startOf("day");

class DateRangePicker extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      startDateTime: props.startDateTime,
      mStartDateTime: moment(props.startDateTime),
      startDtFormat: props.startDtFormat,
      timePeriod: props.timePeriod
    };

    this.onChangeStartDateTime = this.onChangeStartDateTime.bind(this);
    this.onChangeTimePeriod = this.onChangeTimePeriod.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
  }

  static propTypes = {
    onUpdate: func,
    startDateTime: string,
    startDtFormat: string,
    timePeriodOptions: array,
    timePeriod: string,
    showTimePicker: bool.isRequired
  };

  componentWillMount() {
    const { startDateTime, startDtFormat, timePeriod } = this.props;
    this.onUpdate(startDateTime, startDtFormat, timePeriod, true);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.startDateTime !== nextProps.startDateTime ||
      this.props.startDtFormat !== nextProps.startDtFormat ||
      this.props.timePeriod !== nextProps.timePeriod
    ) {
      this.setState({
        startDateTime: nextProps.startDateTime,
        mStartDateTime: moment(nextProps.startDateTime),
        startDtFormat: nextProps.startDtFormat,
        timePeriod: nextProps.timePeriod
      });
    }
  }

  onChangeStartDateTime(newDateTime) {
    const { startDtFormat, timePeriod } = this.props;
    this.onUpdate(newDateTime, startDtFormat, timePeriod, true);
  }

  onChangeTimePeriod(value) {
    const { startDateTime, startDtFormat } = this.props;
    this.onUpdate(startDateTime, startDtFormat, value, true);
  }

  onClickNextButton = () => {
    const { startDateTime, startDtFormat, timePeriod } = this.state;

    const dt = getDateTimes(startDateTime, startDtFormat, timePeriod, true);

    this.onUpdate(dt.startDateTime, startDtFormat, timePeriod, true);
  };

  onClickPreviousButton = () => {
    const { startDateTime, startDtFormat, timePeriod } = this.state;

    const dt = getDateTimes(startDateTime, startDtFormat, timePeriod, false);

    this.onUpdate(dt.startDateTime, startDtFormat, timePeriod, true);
  };

  onUpdate(startDateTime, startDtFormat, timePeriod, doUpdate) {
    const dt = getDateTimes(startDateTime, startDtFormat, timePeriod, null);

    this.props.onUpdate(dt.startDateTime, dt.endDateTime, timePeriod, doUpdate);
  }

  disabledDate(current) {
    // Can not select day as today or future ones
    return current && current >= TODAY;
  }

  render() {
    const mStartDateTime = this.state.mStartDateTime;
    let dt = null;
    if (mStartDateTime.isValid()) dt = mStartDateTime;

    return (
      <div className="cp-date-range-picker test-date-range-picker">
        {/*<Form layout="inline">*/}
        <Form.Item label="Start date">
          <DatePicker
            style={{ width: "120px" }}
            value={dt}
            format="DD/MM/YYYY"
            disabledDate={this.disabledDate}
            onChange={this.onChangeStartDateTime}
            showToday={false}
            allowClear={false}
          />
        </Form.Item>
        {this.props.showTimePicker && (
          <Form.Item>
            <TimePicker
              style={{ width: "80px" }}
              value={dt}
              format="HH:mm"
              disabledDate={this.disabledDate}
              onChange={this.onChangeStartDateTime}
              allowClear={false}
            />
          </Form.Item>
        )}
        <Form.Item label="Time period">
          <Select
            className="select-time-period"
            selectedValue={this.state.timePeriod}
            options={this.props.timePeriodOptions}
            onChange={this.onChangeTimePeriod}
          />
        </Form.Item>
        <Form.Item>
          <Button.Group>
            <Button type="secondary" onClick={this.onClickPreviousButton}>
              <IconLight icon="backward" />
            </Button>
            <Button type="secondary" onClick={this.onClickNextButton}>
              <IconLight icon="forward" />
            </Button>
          </Button.Group>
        </Form.Item>
        {/*</Form>*/}
      </div>
    );
  }
}

const getMomentDateTime = function(rawDt, rawDtInputFormat) {
  const m_dt = moment(rawDt, rawDtInputFormat);
  //TODO add checks for invalid date etc, check for passed input format
  return m_dt;
};

// const getDisplayDateTime = function(dt, displayFormat) {
//   return moment(dt).format(displayFormat);
// };

const getFormattedDateTime = function(m_dt) {
  //	console.log('getFormattedDateTime', m_dt.format("YYYY-MM-DDTHH:mm:ss"));

  return m_dt.format("YYYY-MM-DDTHH:mm:ss");
};

const getTimePeriodFromString = function(timePeriodString) {
  if (!timePeriodString) return null;
  const arr = timePeriodString.split(" ");
  if (arr.length !== 2) {
    console.error(timePeriodString, " timePeriodString not supported");
    return null;
  }
  const amount = arr[0];
  const period = arr[1];
  if (["ms", "s", "m", "h", "d", "w", "M", "Q", "y", "Y"].indexOf(period) < 0) {
    console.error(period, " period not valid");
    return null;
  }

  return { amount: amount, period: period };
};

const getDateTimes = function(
  rawStartDateTime,
  rawStartDateTimeFormat,
  timePeriod,
  isAdd
) {
  let m_startDate = getMomentDateTime(rawStartDateTime, rawStartDateTimeFormat);
  let formattedStartDate = getFormattedDateTime(m_startDate);
  let formattedEndDate = "";
  const tp = getTimePeriodFromString(timePeriod);
  if (tp !== null) {
    //modify start date
    if (isAdd === true) {
      m_startDate = m_startDate.add(tp.amount, tp.period);
    } else if (isAdd === false) {
      m_startDate = m_startDate.subtract(tp.amount, tp.period);
    }

    //format dates
    formattedStartDate = getFormattedDateTime(m_startDate);
    formattedEndDate = getFormattedDateTime(
      m_startDate.add(tp.amount, tp.period)
    );
  }

  return {
    startDateTime: formattedStartDate,
    endDateTime: formattedEndDate
  };
};

export default DateRangePicker;



// WEBPACK FOOTER //
// ./src/views/components/generic/date_range_picker/DateRangePicker.jsx